import { z } from 'zod';
import { ErrorCode } from '../error-codes';
import { DataSourceKindSchema } from './data-source-kind.schema';
import { DataSyncFinishedRunStatusSchema, DataSyncOpenRunStatusSchema } from './data-sync-run.schema';
/** The newest finished run of one source kind. */ const LastRunSchema = z.object({
    id: z.string(),
    status: DataSyncFinishedRunStatusSchema,
    /** Some applied differences ended `failed`. */ hasFailures: z.boolean()
}).nullable();
/** The newest finished run of one source kind and when one was last applied. */ export const DataSyncSourceRunsSchema = z.object({
    lastSyncAt: z.string().nullable(),
    lastRun: LastRunSchema
});
/** Excel is never linked: every upload is a one-time Abgleich. */ export const DataSyncStatusSchema = z.object({
    /** null while Personio is not linked; its runs count only since this link. */ personio: DataSyncSourceRunsSchema.extend({
        linkedAt: z.string()
    }).nullable(),
    excel: DataSyncSourceRunsSchema,
    /** The one open run of the tenant, of either kind. */ openRun: z.object({
        id: z.string(),
        status: DataSyncOpenRunStatusSchema,
        sourceKind: DataSourceKindSchema
    }).nullable()
});
export const DataSyncOkResponseSchema = z.object({
    ok: z.literal(true)
});
export const PersonioCredentialsSchema = z.strictObject({
    clientId: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    clientSecret: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});

//# sourceMappingURL=data-sync.schema.js.map